import React, { useState, useEffect } from 'react';
import InputWithLabel from '../../../component/common/InputWithLabel';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { successToast } from '../../../utils/helper';
import { ApiForRole } from '../challenges/ApiForRole';
// import { Api } from '../../../api';

const initialDetailFormData = {
    ChallegeId: null,
    email_header: '',
    email_body: '',
};

const SendEmail = ({ data, setData }) => {
      const location = useLocation();
      const navigate = useNavigate();
      const state = location.state;
    const [formData, setFormData] = useState(data?.formData || initialDetailFormData);
    const [emailBody, setEmailBody] = useState(formData?.email_body || '');

    const [searchParams] = useSearchParams();
    const queryparams = Object.fromEntries(searchParams);
    const view = queryparams.view || 'edit';

    useEffect(() => {
        setFormData((prev) => ({ ...prev, email_body: emailBody }));
    }, [emailBody]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // const handleSubmit = () => {
    //     const finalFormData = {
    //         EmailHeader:formData?.email_header,
    //         ChallegeId:state?._id,
    //         EmailBody: emailBody,
    //     };

    //     // Example: Call a parent function or API
    //     if (setData) {
    //         setData(finalFormData); // Optional: Update parent state
    //     }

    //     // Replace with your actual submission logic
    //     console.log('Submitting email:', finalFormData);
    //     alert('Email submitted!');
    // };

      const [loader, setLoader] = useState(false);
    
     const handleSubmit = async () => {
        setLoader(true);
        const body = {
            EmailHeader:formData?.email_header,
            challengeId:state?._id,
            EmailBody: emailBody,
        };
        try {
          const response = await ApiForRole().sendEmailWinners(body);
          //   const responseData = response?.data?.winners || {};
          console.log(response?.data, 'fetch by id');
    
          if (response.status === 200) {
            // setTotalCount(response?.data?.meta?.total);
            // setData(responseData);
            successToast(response?.data?.message);
            navigate('/challenges/create-new-challenges?page=preview', {
                state: { _id: state?._id }
            });
            // fetchList(state?._id);
            // const modifiedData = responseData.map((item) => ({
            //   ...item,
            //   gender: item?.gender ? getGenderName(item?.gender?.[0]) : 'N/A'}));
            // setWinnerList(modifiedData || [])
          }
        } catch (error) {
          console.error('Error fetching get wellpoints count:', error);
        } finally {
          setLoader(false);
        }
      };

    return (
        <div>
            <div className="flex flex-col w-full mt-5 bg-white dark:bg-shoorah-darkBgTabColor dark:border-none border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl my-5 lg:p-6 p-4 pb-8 ">
                <div className='max-w-[845px]'>

                    <InputWithLabel
                        label={'Email Header'}
                        placeholder={'Enter Email Header'}
                        containerClassName=""
                        onChange={handleChange}
                        value={formData?.email_header}
                        name={'email_header'}
                        disabled={view === 'preview' || view === 'preview_only'}
                    />

                    <div className="mt-0 max">
                        <h1 className="text-base font-medium my-3">Email Body</h1>
                        <div className="sm:grid sm:grid-cols-12 gap-0 sm:w-[100%] w-full">
                            <div className="col-span-1 sm:col-span-full">
                                <div className="relative">
                                    <textarea
                                        className={`w-full h-[90px] rounded-lg px-5 py-2 bg-[#F5F5F5] border-[1.5px] ${emailBody.length > 500
                                            ? 'border-red-500'
                                            : emailBody.length > 450
                                                ? 'border-yellow-500'
                                                : 'border-[#E7E8EA]'
                                            } text-gray-700 dark:text-gray-300 dark:bg-shoorah-darkBgColor dark:border-none`}
                                        placeholder="Body text"
                                        value={emailBody}
                                        rows={8}
                                        onChange={(e) => {
                                            const newVal = e.target.value.slice(0, 500);
                                            setEmailBody(newVal);
                                        }}
                                        maxLength={500}
                                        disabled={view === 'preview' || view === 'preview_only'}
                                    ></textarea>
                                    <div
                                        className={`text-xs mt-1 text-right ${emailBody.length > 500
                                            ? 'text-red-500'
                                            : emailBody.length > 450
                                                ? 'text-yellow-500'
                                                : 'text-gray-500'
                                            }`}
                                    >
                                        {emailBody.length}/500 characters
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {view !== 'preview' && view !== 'preview_only' && (
                <div className="flex justify-end mt-6">
                    <button
                        type="button"
                        onClick={handleSubmit}
                        className="inline-flex text-xs sm:text-base font-medium items-center justify-center rounded-3xl border bg-shoorah-secondary px-5 py-2 text-white hover:bg-shoorah-primary focus:outline-none w-full sm:w-auto"
                    >
                        Send Email
                    </button>
                </div>
            )}
        </div>
    );
};

export default SendEmail;
